module.exports = "<div class=\"flip-container card-wrapper\" [ngClass]=\"{'rotate': rotate}\">\n  <div class=\"flipper card-rotating effect__click tp-box\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/cards/card-rotating.component.html
// module id = ./src/app/typescripts/pro/cards/card-rotating.component.html
// module chunks = main